module.exports = __webpack_public_path__ + "media/images/pharmacy_placeholder-25c3e28af8f55dd9b2eb65a772b31364.png";